// import React, { useState, useEffect } from 'react';
// import { Navigate } from 'react-router-dom';
// import { ExecutePostWithParams } from '../../services/api/ExecuteApiRequests';

// function Logout() {
//   const [isLoggedOut, setIsLoggedOut] = useState(false);

//   useEffect(() => {
//     const logout = async () => {
//       try {
//         await ExecutePostWithParams(`users/${localStorage.getItem('user-id')}/logout`);
//         localStorage.removeItem('user-id');
//         localStorage.removeItem('token');
//         window.location.reload(false);
//         window.location.replace('/');
//         setIsLoggedOut(true);
//       } catch (error) {
//         console.log(error);
//       }
//     };

//     logout();
//   }, []);

//   return isLoggedOut ? <Navigate to="/" replace /> : null;
// }

// export default Logout;

// pages/Auth/Logout.jsx
import React, { useState, useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { ExecutePostWithParams } from '../../services/api/ExecuteApiRequests';
import { UserContext } from '../../services/contexts/UserContext';

const Logout = () => {
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const { logout } = useContext(UserContext);

  useEffect(() => {
    const performLogout = async () => {
      console.log('Logout component: Starting manual logout process');
      
      try {
        // Set manual logout flag first
        sessionStorage.setItem('manual_logout', 'true');
        
        // Get user ID for API call
        const userId = localStorage.getItem('user-id') || sessionStorage.getItem('user-id');
        
        // Call logout API if we have a user ID
        if (userId) {
          try {
            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            if (token) {
              await ExecutePostWithParams(`users/${userId}/logout`);
              console.log('Logout API call successful');
            }
          } catch (apiError) {
            console.log('Logout API error (non-critical):', apiError);
            // Continue with logout even if API fails
          }
        }
        
        // Call context logout
        logout();
        
        console.log('Manual logout complete');
        setIsLoggedOut(true);
        
        // Redirect to login
        window.location.href = '/';
      } catch (error) {
        console.error('Logout error:', error);
        window.location.href = '/';
      }
    };

    performLogout();
  }, [logout]);

  return isLoggedOut ? <Navigate to="/" replace /> : null;
};

// ✅ THIS IS CRITICAL - Default export
export default Logout;